import { FETCH_STORE } from 'api/Store/constants'
import { combineReducers } from 'redux'
import { FETCH_STORE_DETAILS_SUCCESS } from 'revenue/constants'
import { emptyArray } from 'utils'

import {
  CLOSE_CHANNEL_DETAILS,
  DELAYED_STORES_TAB,
  FETCH_CLOSED_REPORTING_ONLY_STORES,
  FETCH_CLOSED_REPORTING_ONLY_STORES_ERROR,
  FETCH_CLOSED_REPORTING_ONLY_STORES_SUCCESS,
  HIDE_DETAILS,
  OPEN_DETAILS,
  SET_SELECTED_VALUE,
  SHOW_CHANNEL_DETAILS,
} from './constants'

const closedReportingOnlyStores = (state = emptyArray, action) => {
  switch (action.type) {
    case FETCH_CLOSED_REPORTING_ONLY_STORES_SUCCESS:
      return action.data
    case FETCH_CLOSED_REPORTING_ONLY_STORES:
    case FETCH_CLOSED_REPORTING_ONLY_STORES_ERROR:
      return emptyArray
    default:
      return state
  }
}

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_CLOSED_REPORTING_ONLY_STORES:
      return true
    case FETCH_CLOSED_REPORTING_ONLY_STORES_ERROR:
    case FETCH_CLOSED_REPORTING_ONLY_STORES_SUCCESS:
      return false
    default:
      return state
  }
}

const showDetailsInitialState = {
  countryId: null,
  storeId: null,
}

const details = (state = showDetailsInitialState, action) => {
  switch (action.type) {
    case FETCH_STORE:
      return {
        countryId: action.payload.countryId,
        storeId: action.payload.storeId,
      }

    case OPEN_DETAILS:
      return action

    case FETCH_CLOSED_REPORTING_ONLY_STORES:
    case HIDE_DETAILS:
      return showDetailsInitialState

    default:
      return state
  }
}

const channelDetails = (state = showDetailsInitialState, { type, ...data }) => {
  switch (type) {
    case SHOW_CHANNEL_DETAILS:
      return data

    case CLOSE_CHANNEL_DETAILS:
      return null

    default:
      return state
  }
}

const store = (state = null, { type, details: storeDetails = {}, ...data }) => {
  switch (type) {
    case FETCH_STORE_DETAILS_SUCCESS:
      return {
        ...data,
        ...storeDetails,
        details: storeDetails,
      }

    case OPEN_DETAILS:
    case HIDE_DETAILS:
      return null

    default:
      return state
  }
}

const selectedValue = (state = DELAYED_STORES_TAB, { type, value }) => {
  switch (type) {
    case SET_SELECTED_VALUE:
      return value
    default:
      return state
  }
}

export default combineReducers({
  channelDetails,
  closedReportingOnlyStores,
  details,
  isFetching,
  store,
  selectedValue,
})
